import React from 'react';
import { Link } from 'react-router-dom'
import commandsMenu from './images/commandsMenu.png';
import codigosMenu from './images/cofre112v2.png';
import torneosMenu from './images/Games.png';
const Info = () => (
    <div className="topCommands page info">
        <div className='navTops heroes unselectable'>
          <div>
            <Link id="son" to="/info/commands"><img src={commandsMenu} alt="Comandos"/><span>Comandos</span></Link>
          </div>
          <div>
            <Link id="son" to="/codigos"><img src={codigosMenu} alt="Códigos"/><span>Códigos</span></Link>
          </div>
          <div>
            <Link id="son" to="/info/torneos"><img src={torneosMenu} alt="Torneos"/><span>Torneos</span></Link>
          </div>
        </div>
    </div>
)

export default Info